import { createContext, useContext } from 'react'
import type { PropsWithChildren } from 'react'

type SubRoute = {
  planningVersions: (id: string) => string
  index: () => string
}

const Context = createContext<SubRoute | null | undefined>(null)

interface Props {
  baseRoute: SubRoute
}

export const RouteProvider = ({ children, baseRoute }: PropsWithChildren<Props>) => {
  return <Context.Provider value={baseRoute}>{children}</Context.Provider>
}

export const useRoute = (): SubRoute => {
  const route = useContext(Context)

  if (!route) throw new Error('useRoute must be used within a RouteProvider')

  return route
}
